<script setup>
import { ref } from 'vue';

const emit = defineEmits('reloadSignatureRequests');

const modal = ref(null);
const addingSelf = ref(false);

const props = defineProps({
    expertContractId: {
        type: Number,
        required: true,
    },
    currentUserIsRecipient: {
        type: Boolean,
        required: false,
        default: true,
    },
    activeWorkflow: {
        type: Boolean,
        required: false,
        default: false,
    },
    activeWorkflowName: {
        type: String,
        required: false,
        default: null
    }
});

const addSelfAsSignee = async () => {
    addingSelf.value = true;
    const response = await axios.post(
        route(
            'expert-contracts.signature-requests.for-current-user',
            props.expertContractId
        )
    );
    emit('reloadSignatureRequests');
};

const closeModalAndReload = () => {
    modal.value.closeModal();
    emit('reloadSignatureRequests');
};
</script>
<template>
    <div class="flex justify-end space-x-2">
        <button-primary
            v-if="!props.currentUserIsRecipient && !addingSelf"
            @click="addSelfAsSignee"
        >
            {{ _mft('expertContract:addSignee.addSelf') }}
        </button-primary>

        <general-modal ref="modal">
            <template v-slot:header>{{ addingSelf ? _mft('expertContract:addSignee.addSelf') : _mft('expertContract:addSignee.addSignee') }}</template>
            <template v-slot:body>
                <expert-contract-signature-requests-create
                    :expert-contract-id="props.expertContractId"
                    :expert-pro-active="true"
                    :active-workflow="props.activeWorkflow"
                    :active-workflow-name="props.activeWorkflowName"
                    @reloadSignatureRequests="closeModalAndReload"
                />
            </template>
            <template v-slot:open>
                <button-primary>{{ _mft('expertContract:addSignee.addSignee') }}</button-primary>
            </template>
        </general-modal>
    </div>
</template>
